/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForDeviceFirmwareUpgradeElementResponse,
    ReportForDeviceFirmwareUpgradeElementResponseFromJSON,
    ReportForDeviceFirmwareUpgradeElementResponseFromJSONTyped,
    ReportForDeviceFirmwareUpgradeElementResponseToJSON,
} from './ReportForDeviceFirmwareUpgradeElementResponse';

/**
 * 
 * @export
 * @interface ReportForDeviceResponseDeviceUpgradeHistoryElement
 */
export interface ReportForDeviceResponseDeviceUpgradeHistoryElement {
    /**
     * 
     * @type {ReportForDeviceFirmwareUpgradeElementResponse}
     * @memberof ReportForDeviceResponseDeviceUpgradeHistoryElement
     */
    loader: ReportForDeviceFirmwareUpgradeElementResponse;
    /**
     * 
     * @type {ReportForDeviceFirmwareUpgradeElementResponse}
     * @memberof ReportForDeviceResponseDeviceUpgradeHistoryElement
     */
    firmware: ReportForDeviceFirmwareUpgradeElementResponse;
    /**
     * 
     * @type {ReportForDeviceFirmwareUpgradeElementResponse}
     * @memberof ReportForDeviceResponseDeviceUpgradeHistoryElement
     */
    ui: ReportForDeviceFirmwareUpgradeElementResponse;
    /**
     * 
     * @type {ReportForDeviceFirmwareUpgradeElementResponse}
     * @memberof ReportForDeviceResponseDeviceUpgradeHistoryElement
     */
    customFirmware1: ReportForDeviceFirmwareUpgradeElementResponse;
    /**
     * 
     * @type {ReportForDeviceFirmwareUpgradeElementResponse}
     * @memberof ReportForDeviceResponseDeviceUpgradeHistoryElement
     */
    customFirmware2: ReportForDeviceFirmwareUpgradeElementResponse;
    /**
     * 
     * @type {ReportForDeviceFirmwareUpgradeElementResponse}
     * @memberof ReportForDeviceResponseDeviceUpgradeHistoryElement
     */
    customFirmware3: ReportForDeviceFirmwareUpgradeElementResponse;
}

export function ReportForDeviceResponseDeviceUpgradeHistoryElementFromJSON(json: any): ReportForDeviceResponseDeviceUpgradeHistoryElement {
    return ReportForDeviceResponseDeviceUpgradeHistoryElementFromJSONTyped(json, false);
}

export function ReportForDeviceResponseDeviceUpgradeHistoryElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceResponseDeviceUpgradeHistoryElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loader': ReportForDeviceFirmwareUpgradeElementResponseFromJSON(json['loader']),
        'firmware': ReportForDeviceFirmwareUpgradeElementResponseFromJSON(json['firmware']),
        'ui': ReportForDeviceFirmwareUpgradeElementResponseFromJSON(json['ui']),
        'customFirmware1': ReportForDeviceFirmwareUpgradeElementResponseFromJSON(json['customFirmware1']),
        'customFirmware2': ReportForDeviceFirmwareUpgradeElementResponseFromJSON(json['customFirmware2']),
        'customFirmware3': ReportForDeviceFirmwareUpgradeElementResponseFromJSON(json['customFirmware3']),
    };
}

export function ReportForDeviceResponseDeviceUpgradeHistoryElementToJSON(value?: ReportForDeviceResponseDeviceUpgradeHistoryElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loader': ReportForDeviceFirmwareUpgradeElementResponseToJSON(value.loader),
        'firmware': ReportForDeviceFirmwareUpgradeElementResponseToJSON(value.firmware),
        'ui': ReportForDeviceFirmwareUpgradeElementResponseToJSON(value.ui),
        'customFirmware1': ReportForDeviceFirmwareUpgradeElementResponseToJSON(value.customFirmware1),
        'customFirmware2': ReportForDeviceFirmwareUpgradeElementResponseToJSON(value.customFirmware2),
        'customFirmware3': ReportForDeviceFirmwareUpgradeElementResponseToJSON(value.customFirmware3),
    };
}

